import React from 'react';
import { Modal, Button, Typography, message } from 'antd';
import useGraphqlService from "../../../util/useGraphqlService";
import {UPDATE_ENTRY_TO_BUCKET_PULL_MUTATAION} from "../../../constants/graphql/entryQueries";
import moment from "moment/moment";

const EntryDetailsModal = ({ isVisible, onClose, entryDetails, onConfirm }) => {
    const { sendGraphqlRequest } = useGraphqlService();

    const handleConfirm = async () => {
        try {
            const payload = {
                id: parseInt(entryDetails?.id)
            }
            await sendGraphqlRequest(UPDATE_ENTRY_TO_BUCKET_PULL_MUTATAION, { input: payload });
            onConfirm(); // Trigger a callback that can be used to refresh data
            onClose(); // Close the modal after the mutation
        } catch (error) {
            console.error('Failed to update entry:', error);
            message.error("Failed to confirm bucket pull. Please try again.")
        }
    };

    return (
        <Modal
            title="Entry Details"
            visible={isVisible}
            onCancel={onClose}
            footer={[
                <Button key="back" onClick={onClose}>Return</Button>,
                <Button key="submit" type="primary" onClick={handleConfirm}>
                    Confirm as Bucket Pull
                </Button>
            ]}
        >
            {entryDetails ? (
                <>
                    <Typography.Text><strong>Name:</strong> {entryDetails.paperName}</Typography.Text><br />
                    <Typography.Text><strong>Created At:</strong> {moment(entryDetails.createdAt).format('MMMM Do YYYY, h:mm:ss a')}</Typography.Text>
                </>
            ) : (
                <Typography.Text>Loading...</Typography.Text>
            )}
        </Modal>
    );
};

export default EntryDetailsModal;
